module.exports = __webpack_public_path__ + "static/media/IITK_CERTIFICATE -VISHWAA_M_S.335ee498.jpg";